import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "custom-checkbox__icon",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "21",
  height: "21",
  x: ".5",
  y: ".5",
  fill: "#FFF",
  stroke: "#212529",
  rx: "3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#212529",
  "stroke-linecap": "round",
  "stroke-width": "4",
  d: "m4 10 5 5 9-9",
  class: "tick"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }